module.exports = __webpack_public_path__ + "img/File-word.db04d563.svg";